// src/services/api/utils.ts
import { API_BASE_URL } from './client';

/**
 * Interface for paginated API responses
 */
export interface PaginatedResponse<T> {
  items: T[];
  total_count: number;
  total_pages: number;
  current_page: number;
}

/**
 * Helper function to format a Date object as YYYY-MM-DD for API
 */
export const formatDateForApi = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

/**
 * Re-export API_BASE_URL for convenience
 */
export { API_BASE_URL };